import { ChangeDetectorRef, Component, OnInit , DestroyRef} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {Title} from "@angular/platform-browser";
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from "@angular/router";
import {filter} from "rxjs";
import {LanguageService} from "./utils/language/language.service";
import { PermissionService } from './auth/permissions/permission.service';
import { AuthService } from './auth/auth.service';
import { AgGridFilterClearService } from './utils/ag-grid-filter-clear/ag-grid-filter-clear.service';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
    permissionsLoaded = false;
    constructor(private translate: TranslateService,
                private titleService: Title,
                private router: Router,
                private _changeDetectorRef: ChangeDetectorRef,
                private activatedRoute: ActivatedRoute,
                private permissionService: PermissionService,
                private authService: AuthService,
                private languageService: LanguageService,
                private agGridFilterClearService: AgGridFilterClearService,
                private readonly destroyRef: DestroyRef) {
        translate.addLangs(this.languageService.supportedLanguages);

    }

    ngOnInit() {
        // Křížek pro vymazání textu v ag-grid filtrech napříč celou aplikací.
        this.agGridFilterClearService.init();

        if (this.authService.accessToken) {
            this.permissionService.loadPermissions().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
                this.permissionsLoaded = true;
                this._changeDetectorRef.detectChanges();
                this._changeDetectorRef.markForCheck();
            }, () => {
                this.permissionsLoaded = true;
                this._changeDetectorRef.detectChanges();
                this._changeDetectorRef.markForCheck();
            });
        } else {
            this.permissionsLoaded = true;
        }

        this.router.events.pipe(takeUntilDestroyed(this.destroyRef), 
            filter(event => event instanceof NavigationEnd),
        )
            .subscribe(() => {

                const rt = this.getChild(this.activatedRoute)

                rt.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
                    if (data?.title) {
                        this.titleService.setTitle(this.translate.instant(data.title))
                    }
                })
            })
    }

    getChild(activatedRoute: ActivatedRoute) {
        if (activatedRoute.firstChild) {
            return this.getChild(activatedRoute.firstChild);
        } else {
            return activatedRoute;
        }

    }
}
